module.exports = __webpack_public_path__ + "img/c-thermometer-img8-2.66fd4639.png";